import { Icon, IFormRender } from '@busybusy/webapp-react-ui';
import { ArrowDownIcon } from 'assets/icons';
import BasicPickerFormField from 'components/foundation/form-fields/BasicPickerFormField/BasicPickerFormField';
import { IBasicPickerValue } from 'components/foundation/pickers/basic-picker/BasicPicker/BasicPicker';
import { t } from 'i18next';

import { PositionManageBudgetType } from 'utils/positionUtils';

export interface IBudgetFormFieldsProps<T extends IBudgetFieldsData> {
  form: IFormRender<T>;
}

export interface IBudgetFieldsData {
  manageBudgets: PositionManageBudgetType;
}

function BudgetFormFields<T extends IBudgetFieldsData>({ form }: IBudgetFormFieldsProps<T>) {
  const basicPickerOptions: Array<IBasicPickerValue<PositionManageBudgetType>> = [
    { id: PositionManageBudgetType.OFF, name: t('Off') },
    { id: PositionManageBudgetType.VIEW_ONLY, name: t('View Only') },
    { id: PositionManageBudgetType.MANAGE, name: t('Manage') },
  ];

  return (
    <>
      <BasicPickerFormField
        name="manageBudgets"
        data={basicPickerOptions}
        form={form}
        closeButtonRender={() => (
          <span className="drop-icon">
            <Icon svg={ArrowDownIcon} />
          </span>
        )}
      />
    </>
  );
}

export default BudgetFormFields;
